import { AxiosInstanceProvider } from '../../../core/hooks';
import { mapPaginationViewToApiModel, PaginationViewModel } from '../../../core/model';
import { extractTotalCountHeaderFromAxiosHeader } from '../../../core/utils';
import { ItsmHttpQueryConfig } from '../../config';
import { ItsmMaintenanceWorkApiModel, ItsmMaintenanceWorkViewModel, mapItsmMaintenanceWorkApiModelToViewModel } from '../../model';

export interface ItsmMaintenanceWorksHttpGetPayloadModel {
  customerId: number;
  pagination: PaginationViewModel;
}

type ItsmMaintenanceWorksHttpGetViewModel = {
  data: ItsmMaintenanceWorkViewModel[];
  total: number;
};

export const getItsmMaintenanceWorks = async (
  axios: AxiosInstanceProvider,
  { customerId, pagination }: ItsmMaintenanceWorksHttpGetPayloadModel,
): Promise<ItsmMaintenanceWorksHttpGetViewModel> => {
  const url = ItsmHttpQueryConfig['GetItsmMaintenanceWorks'].url.replace('{customerId}', customerId.toString(10));
  const requestConfiguration = {
    params: mapPaginationViewToApiModel(pagination),
  };
  const response = await axios().get<ItsmMaintenanceWorkApiModel[]>(url, requestConfiguration);
  return {
    data: response.data.map(mapItsmMaintenanceWorkApiModelToViewModel),
    total: extractTotalCountHeaderFromAxiosHeader(response),
  };
};